import React from 'react';

const Activity = (props) => {
    const {timeHandler} = props;
    const {name, img, timeRequired} = props.activity;

    return (
        <div className="p-2 bg-white drop-shadow-lg rounded-xl border-lime-500 border-2">
            <img className="rounded-t-md w-full" src={"images/" + img} alt="" />
            <h3 className="font-bold mt-4 text-right">{name}</h3>
            <p className="mt-2 text-right">
                <span className="text-sm ">Time Required: </span>
                <span className="font-bold">{timeRequired}hr</span>
            </p>
            <button onClick={() => timeHandler(+timeRequired)} className="mt-2 bg-lime-500 text-white font-bold w-full rounded-md py-2">Add to list</button>
        </div>
    );
};

export default Activity;